import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { RelatorioContasPagarRequest } from '../../requests/financas/relatorio-contas-pagar.request';
import { SaveRelatorioFiltroFavoritoRequest } from '../../requests/financas/save-relatorio-filtro-favorito.request';
import { SaveRelatorioFiltroFavoritoResponse } from '../../responses/financas/relatorio-filtro-favorito.response';
import {
    RelatorioContasPagarLookupResponse,
    RelatorioContasPagarResponse
} from '../../responses/financas/relatorio-contas-pagar.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root'
})
export class RelatorioContasPagarService extends CommonService {
    private readonly apiUrl = `${environment.urlApiFinancas}RelatorioContasPagar`;

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getLookup(): Observable<RelatorioContasPagarLookupResponse> {
        return this.httpClient
            .get<RelatorioContasPagarLookupResponse>(`${this.apiUrl}/lookup`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getPreview(request: RelatorioContasPagarRequest): Observable<RelatorioContasPagarResponse> {
        return this.httpClient
            .post<RelatorioContasPagarResponse>(`${this.apiUrl}/preview`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public saveFavorito(request: SaveRelatorioFiltroFavoritoRequest): Observable<SaveRelatorioFiltroFavoritoResponse> {
        return this.httpClient
            .post<SaveRelatorioFiltroFavoritoResponse>(`${this.apiUrl}/favorito`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteFavorito(idRelatorioFiltroFavorito: number): Observable<ReturnStruct> {
        return this.httpClient
            .delete<ReturnStruct>(`${this.apiUrl}/favorito/${idRelatorioFiltroFavorito}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
